import $ from 'jquery';
import SiteHeader from "./site-header";

/**
 * Fits an element to its parent
 * @param $el
 * @param options
 */
var Fit = {
    initialised: false
};

/**
 * Add
 */
Fit.init = function()
{
    if (this.initialised) {
        return;
    }

    $(window).on('resize load', function(e) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(function() {
            this.update();
        }.bind(this), 10);
    }.bind(this));

    this.update();

    this.initialised = true;
}

/**
 * Update all elements
 */
Fit.update = function()
{
    $('[data-fit]').each(function(i, el) {
        var $el = $(el);
        var opts = $.extend({}, Fit.defaults, $el.data());
        this[opts.fit]($el, opts);
    }.bind(this));
}

/**
 * "cover" sizing mode
 */
Fit.cover = function($el, opts)
{
    var $parent = $el.parent();
    var ratio = opts.fitWidth / opts.fitHeight;
    var parentWidth = Math.ceil($parent.width());
    var parentHeight = Math.ceil($parent.height()) + opts.paddingTop;
    var width = Math.ceil(parentWidth);
    var height = Math.round(width / ratio);

    if (height < parentHeight) {
        height = parentHeight;
        width = Math.round(height * ratio);
    }

    $el.css({
        'width': width,
        'height': height,
        'margin-top': Math.round(parentHeight - height) - opts.paddingTop,
        'margin-left': Math.round(parentWidth - width)
    });
}

Fit.defaults = {
    fit: 'cover',
    fitWidth: 1280,
    fitHeight: 720,
    paddingTop: 80
};

export default Fit;